import { Messages } from '../../../../codegen/Localize';
import { IServerUserInfo } from '../../../../ts/models/IServerUserInfo';
import { serverUserEditSiteMembership } from '../../../actions/spaces/ServerUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectServerUserGuest } from './IEntityActionHelpers';

export const ServerUserEditSiteMembershipUsersAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserEditSiteMembership,
  translateName: Messages.siteMembership_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return true;
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserEditSiteMembership(targetItems)
};
